import { css } from 'styled-components';
export default {
    navHeight: 175,
    navHeightMobile: 92,
    siteWideWidth: 1760,
    siteWideWidthNarrow: 1430,
    siteWideWidthInner: 860,
    siteWidePadding: 36,
    siteWidePaddingTablet: 26,
    siteWidePaddingMobile: 15,
};
export const ButtonReset = css `
  border: none;
  outline: none;
  padding: 0px;
  background: none;
  border-radius: 0px;
`;
